<style>
@import '../../../custom/css/lista-dicas.css';

/* #representantes .limit-table::-webkit-scrollbar:vertical {
  display: none;
} */
</style>

<template>
  <div id="representantes">
    <h1 class="title text-uppercase font-weight-bold">
      Profissionais Indicados
    </h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th></th>
          <th>Nome</th>
          <th>Cidade</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(professional, index) in getIndicatedProfessionals"
          :key="index"
        >
          <td class="font-weight-bold fs-20">
            {{ index + 1 }}
          </td>
          <td>
            {{ professional.nome || 'Sem nome' }}
          </td>
          <td>
            {{ professional.cidade || 'Sem cidade' }}
          </td>
          <td>
            <b-btn
              class="btn-warning mr-1"
              @click="see(professional.id)"
              title="Ver"
            >
              <i class="fas fa-eye"></i>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <b-modal
      title="Ver profissional indicado"
      id="seeIndicatedProfessional"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <section>
        <div class="row mb-4">
          <div class="col-6">
            <span class="font-weight-bold">Nome</span>
            <p>{{ getIndicatedProfessional.nome }}</p>
          </div>
          <div class="col-6">
            <span class="font-weight-bold">Cidade</span>
            <p>{{ getIndicatedProfessional.cidade }}</p>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-6">
            <span class="font-weight-bold">Serviços</span>
            <p>
              <span
                v-for="(service, index) in getIndicatedProfessional.servicos"
                :key="index"
              >
                {{ service
                }}{{
                  index + 1 === getIndicatedProfessional.servicos.length
                    ? ''
                    : ','
                }}
              </span>
            </p>
          </div>
          <div class="col-6">
            <span class="font-weight-bold">Celular</span>
            <p>
              {{ getIndicatedProfessional.celular }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span class="font-weight-bold">Indicado por:</span>
            <p>{{ getIndicatedProfessional.afiliado }}</p>
          </div>
          <div class="col-6">
            <span class="font-weight-bold">Data de indicação:</span>
            <p>{{ getIndicatedProfessional.data_indicacao }}</p>
          </div>
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'IndicatedProfessionals',
  mixins: [makeToast],
  computed: {
    ...mapGetters('professional', [
      'getIndicatedProfessionals',
      'getIndicatedProfessional',
    ]),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getAllIndicated().finally(() => this.$store.dispatch('endLoader'));
  },
  methods: {
    ...mapActions('professional', ['getAllIndicated', 'getIndicated']),
    see(id) {
      this.$store.dispatch('startLoader');
      this.getIndicated(id)
        .then(() => {
          this.$bvModal.show('seeIndicatedProfessional');
        })
        .catch(() => {
          this.makeToast(
            'Oopss',
            'Houve algum problema ao visualizar esse usuário',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>
